module.exports = require("json-schema-faker");